var offerNextGenSearchFilterTemplate = require('templates/offerNextGenSearchFilter.hbs');
var AriesComponent = require('libs/aries-component');
var PageTakeover = require('libs/pageTakeover');
var ResponsiveUtils = require('utils/responsiveUtils');
var localStorage = require('local-storage-fallback');
var PubSub = require('libs/pub-sub');
var $ = require('jquery');
var Constants = require('libs/constants');
var Config = require('libs/config');
var Loader = require('libs/loader');


PubSub.register(AriesComponent.extend({
  type: 'offerNextGenSearchFilter',
  template: {
    'offerNextGenSearchFilter': offerNextGenSearchFilterTemplate
  },
  state: {},
  selectionOrder: [],
  selectedOrder: [],
  subscribe: {
    'HIDE_FILTERS_PANEL': 'hideSortAndFilters',
    'SHOW_BRAND_FILTER' : 'openSortAndFilters'
  },
  events: {
    'click .cta-sort-and-filter': 'openSortAndFilters',
    'keypress .cta-sort-and-filter': 'openSortAndFilters',
		'click .m-dropdown': 'dropDownMouseHandler',
		'keypress .m-dropdown': 'dropKeyBoradHandler',
		'blur .m-dropdown-list': 'onMenuBlurHandler',
    'click .m-dropdown .m-dropdown-option': 'onMemuItemSelected',
    'click .cta-hide-sort-and-filter': 'hideSortAndFilters',
    'keypress .cta-hide-sort-and-filter': 'hideSortAndFilters',
    'change .cta-filter': 'onFilterSelected',
    'change .cta-sort': 'onSortBySelected',
    'click .l-filters .js-accordion-toggle': 'onAccordionOpen',
    'keypress .l-filters .js-accordion-toggle': 'adaAccordionOpen',
    'click .cta-reset': 'resetForm',
    'click .js-brand-icon' : 'brandIconClickHandler',
    'click .select-all-category-labels' : 'selectAllCategoryLabels',
    'click .clear-all-category-labels' : 'clearAllCategoryLabels',
    'click .cta-offer-sort-and-filter' : 'showAllFilters',
    'click .cta-hide-offer-sort-and-filter' : 'hideAllFilters'
  },
  options: {
    'SORT_AND_FILTER_MODEL': '.js-sort-and-filter',
    'DISPLAY_ONLY_FORM': '.js-form-display-only',
    'SUBMIT_FORM': '.js-submit-form',
    'CTA_FILTERS': '.cta-hide-sort-and-filter',
    'SORT_AND_FILTER_FROM': '.js-sort-and-filter-form'
  },
  bindEvents: function() {
    var _self = this;
    if($('[data-component-id="' + _self.componentId + '"]').hasClass('tile-search-filter') == false) {
      return;
    }
    var $submitForm = _self.$el.find(_self.options.SUBMIT_FORM);
    _self.initResponsiveUtils();
    _self.refinedSearchUrl = _self.$el.data('refine-search-url');
    if (typeof(_self.initialAppliedFilters) !== 'object') {
      _self.$el.parents('.mi-sub-section').css({position: 'relative'});
      _self.initialAppliedFilters = _self.serializeForm();
      $.each($submitForm[0].elements, function(index, input) {
        if( _self.initialAppliedFilters[input.name] && _self.initialAppliedFilters[input.name].length )
          input.value = JSON.stringify(_self.initialAppliedFilters[input.name])
      });
      $submitForm.find('[name="filter"]').val(_self.initialAppliedFilters.filter);
      _self.selectedOrder = _self.$el.data('filtertags') ? _self.$el.data('filtertags') : [];
      $submitForm.find('[name="selectionOrder"]').val(JSON.stringify(_self.selectedOrder));
    } else {
      this.$el.parents('.mi-sub-section').css({position: 'static'});
    }
    
    if( this.$el.find(this.options.SORT_AND_FILTER_MODEL).is(':visible') )
      this.pubsub.publish('HIDE_STICKY_SEARCH_FORM');
  },
  /**
  * This function is used to initiate responsive utils
  */
  initResponsiveUtils: function() {
    this.responsiveUtils = ResponsiveUtils.create({
      // orientationChangeEventHandler: _.bind(this.orientationChangeEventHandler, this),
      resizeEventHandler: _.bind(this.resizeEventHandler, this)
    });
    this.responsiveUtils.init();
  },

  /**
  * This function is used to remove pagetakeover styling on resize event.
  */
  resizeEventHandler: function() {
    var $displayForm = this.$el.find(this.options.DISPLAY_ONLY_FORM);
  },
  
  /**
   * Create the Div Element which helps block the screen
   */
  initScreenBlock: function() {
    this.$subSection = this.$el.parents('.mi-sub-section');
    this.$subSection.css({position: 'static'});
  },

  /**
   * CTA handler for Filter Button
   */
  openSortAndFilters: function(event) {
    var charCode = event.which || event.key.charCodeAt(0),
    $currentFilter = $(event.currentTarget).data('target');
    this.initScreenBlock();
    if( ( "keypress" === event.type && (13 === charCode || 32 === charCode) ) || "click" === event.type ) {
      event.preventDefault();
      this.showSortAndFilters();
      //this.pubsub.publish('ADJUST_MENU_HEIGHT');
      if($currentFilter){
        if(this.$el.find('div.js-accordion-toggle.open').length > -1 && this.$el.find('div.js-accordion-toggle.open').data('accordion') === $currentFilter ){
          //do nothing
        }else{
          this.$el.find('div.js-accordion-toggle.open').trigger('click');
          this.$el.find('[data-accordion="'+$currentFilter+'"]').trigger('click');
        }
      }
      this.pubsub.publish('ADJUST_MENU_HEIGHT');
    }
  },

  /**
   * Handler for Sort & Filter CTA
   */
  showSortAndFilters: function() {
    var _self=this;
    if(_self.$el.find('.cta-sort-and-filter').data('searchkey')){
      var isTileDisplayed=false;
      _self.$el.find('.cta-sort-and-filter').parent('.l-filter-container').removeClass('l-display-block').addClass('l-display-none');
      _self.pubsub.publish('TOGGLE_PAGE_HEADER',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_RESULT_SUMMARY',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_REGION_NAV',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_CROSS_LINKS',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_CONNECT_US',[isTileDisplayed]);
      _self.$el.find('.cta-sort-and-filter').addClass('l-display-none');
      $(window).scrollTop(0);
      _self.$el.find(_self.options.SORT_AND_FILTER_MODEL).removeClass('l-display-none');
      _self.$el.find(_self.options.CTA_FILTERS).attr('aria-expanded', 'true');    
      _self.pubsub.publish('SEARCH_FILTER_VISIBLE');
    }else{
      _self.pubsub.publish('HIDE_STICKY_SEARCH_FORM');
      // this.pubsub.publish('STICKY_SCROLL_TOP');
      $(window).scrollTop(0);
      _self.$el.find(_self.options.SORT_AND_FILTER_MODEL).removeClass('l-display-none');
      _self.$el.find(_self.options.CTA_FILTERS).attr('aria-expanded', 'true');    
      _self.pubsub.publish('SEARCH_FILTER_VISIBLE');
    }
    _self.pubsub.publish('TOGGLE_FOOTER_FILTER', [false]);
  },

  /**
   * Hide the Sort & Filter Model
   */
  hideSortAndFilters: function() {
    var _self=this;
    this.$el.parents('.mi-sub-section').css({position: 'relative'});
    if(!_.isEqual(_self.initialAppliedFilters,_self.serializeForm())) {
      _self.refresh(_self.initialAppliedFilters, function() {
        window.$(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-foundation');

        var $submitForm = _self.$el.find(_self.options.SUBMIT_FORM);
        $.each($submitForm[0].elements, function(index, input) {
          if( _self.initialAppliedFilters[input.name] && _self.initialAppliedFilters[input.name].length )
            input.value = JSON.stringify(_self.initialAppliedFilters[input.name])
        });
        _self.selectedOrder = _self.$el.data('filtertags') ? _self.$el.data('filtertags') : [];
      }, function(error) {
        window.location.replace(_self.$el.data(Constants.FILTER.ERROR_REDIRECT_URI));
      });
    }
    if(_self.$el.find('.cta-sort-and-filter').data('searchkey')){
      var isTileDisplayed=true;
      _self.$el.find('.cta-sort-and-filter').parent('.l-filter-container').removeClass('l-display-none').addClass('l-display-block');
      _self.pubsub.publish('TOGGLE_PAGE_HEADER',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_RESULT_SUMMARY',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_REGION_NAV',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_CROSS_LINKS',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_CONNECT_US',[isTileDisplayed]);
      _self.$el.find('.cta-sort-and-filter').removeClass('l-display-none');
      _self.$el.find(_self.options.SORT_AND_FILTER_MODEL).addClass('l-display-none');
      _self.$el.find(_self.options.CTA_FILTERS).attr('aria-expanded', 'false');    
      _self.pubsub.publish('SEARCH_FILTER_VISIBLE');
    }else{
      _self.pubsub.publish('SEARCH_FILTER_HIDDEN');
      _self.$el.find(this.options.SORT_AND_FILTER_MODEL).addClass('l-display-none');
      _self.$el.find(this.options.CTA_FILTERS).attr('aria-expanded', 'false');
      _self.pubsub.publish('TOGGLE_STICKY_PANEL');
    }
    _self.pubsub.publish('TOGGLE_FOOTER_FILTER', [true]);
  },

  	/**
	 * Dropdown menu mouse event handler
	 */
	dropDownMouseHandler: function(evt) {
		if( !$(evt.target).hasClass('m-dropdown-option') )
			this.openDropDown(evt.currentTarget);
	},
	
	/**
	 * Dropdown menu keyborad event handler
	 */
	dropKeyBoradHandler: function(evt) {
    var charCode = evt.charCode || evt.which;
		if( 13 === charCode || 32 === charCode ) {
      evt.preventDefault();
			if( $(evt.target).hasClass('m-dropdown-option') )
				this.onMemuItemSelected({currentTarget: evt.target});
			else
				this.openDropDown(evt.currentTarget);
		}	
	},

	/**
	 * Event handler for sort dropdown value selection
	 */
	onMemuItemSelected: function(evt) {
		var $menuOption = $(evt.currentTarget);
		if( !$menuOption.hasClass('current-value') ) {
			var paramName = $menuOption.data('bucket');
			var value = $menuOption.data('value');
      this.setFilterBy(paramName, value);
      this.submitSortBy();
		}
		this.hideMenu($menuOption);
	},

	/**
	 * On Blur Menu Event Handler, helps hide the menu when focus is lost
	 */
	onMenuBlurHandler: function(evt) {
		if(!evt.relatedTarget || !$(evt.currentTarget).find(evt.relatedTarget).length)
			this.hideMenu(evt.currentTarget);
  },
  
  /**
	 * Hide the menu based on any given item in the menu or menu it self
	 */
	hideMenu: function(menu) {
		var $menu = $(menu);
		if( !$menu.hasClass('.m-dropdown') )
			$menu = $menu.parents('.m-dropdown');
		$menu.removeClass('in-focus');			
	},

  /**
	 * Open the menu
	 */
	openDropDown: function(menu) {
		var $menu = $(menu);
		var $list = $menu.find('.m-dropdown-list');

		if( $menu.hasClass('in-focus') )
			$menu.removeClass('in-focus');
		else {
			$menu.addClass('in-focus');
			$list.find('.m-dropdown-option').first().focus();
		}
  },
  
  /**
   * CTA Handler for On Change Search Filter
   */
  onFilterSelected: function(evt) {
    evt.preventDefault();
    var input = evt.currentTarget;
    if ($(input).data('type') != 'rangeFilter') {
      if( input.checked ) {
        this.selectedOrder.push(
          {"bucketName": input.name, "code": input.value, "label": this.$el.find('[for="' + input.id + '"]').text() }
        );
      } else {
        this.selectedOrder = _.filter(this.selectedOrder, function(item) {
          return !(item.bucketName === input.name && item.code === input.value);
        });
      }
    }
    this.updateFilters();
  },

  /**
   * CTA handler for drop-down menu handler
   */
  setFilterBy: function(sortBy, index) {
    var $elements = $(this.$el.find(this.options.DISPLAY_ONLY_FORM)[0].elements);
    $elements.filter('[data-type="rangeFilter"][name="' + sortBy + '"][value="' + index + '"]').prop("checked", true);
    $elements.filter('[data-availability-filter=' + '"' + sortBy + '"]').each(function(index, item) {
      $(item).attr("data-checked",false);
    });
    $elements.filter('[data-availability-filter=' + '"' + sortBy + '"][value="' + index + '"]').attr("data-checked", true);
    if (sortBy === "distanceUnit") {
      this.$el.find('[name=' + sortBy + ']').val(index);
    }
  },

  /**
   * CAT handler for sort by value selected
   */
  onSortBySelected: function(evt) {
    evt.preventDefault();
    var input = evt.currentTarget;
    if( input.checked ) {
      var location = window.location;
      var queryParams = {};
      if( location.search ) {
        location.search.substr(1).split('&').forEach(function findParam(param) {
          var params = param.split('=');
          if(params[0] == "sort"){
            queryParams[params[0]] = params[1];
          }
        })
      }
      queryParams[input.name] = input.value;
      
      window.location = this.refinedSearchUrl +'?'+$.param(queryParams);
    }
  },

  /**
   * Serialize Form the inputs form
   */
  serializeForm: function() {
    if ($(".tile-search-filter").length > 0) {
      var $elements = $(this.$el.find(this.options.DISPLAY_ONLY_FORM)[0].elements);
      var payload = { facets: [], rangeFilter: []}
      var facets = {}, rangeFilter = {};
      $elements.filter('[data-type="facets"]:checked').each(function(index, input) {
        if( !facets[input.name] )
          facets[input.name] = [];
        facets[input.name].push(input.value);
      });
  
      Object.keys(facets).forEach(function(value) {
        var item = {};
        item[value] = facets[value];
        payload.facets.push(item);
      })
  
      $elements.filter('[data-type="rangeFilter"]:checked').each(function(index, input) {
        if( !rangeFilter[input.name] )
          rangeFilter[input.name] = [];
  
        if( input.value ) {
          rangeFilter[input.name].push(input.value);
        }
      });
  
      Object.keys(rangeFilter).forEach(function(value) {
        if( rangeFilter[value] ) {
          var item = {};
          item[value] = rangeFilter[value];
          payload.rangeFilter.push(item);          
        }
      });
      $elements.filter('input[data-type="availabilityFilter"][data-checked="true"]').each(function(index,input) {
         payload.filter = $(input).val() === "true" ? true : false;
      });
      $elements.filter('input[data-type="availability-filters"]').each(function(index,input) {
         payload.showAvailableHotels = input.checked ? true : false;
      });
      return payload;
    }
  },

  updateFilters: function() {
    this.$el.find(this.options.SORT_AND_FILTER_FROM).css({display: 'none'});

    var _self = this;
    $(window).scrollTop(0);
    var submitPayload = this.serializeForm();
    this.$el.find(_self.options.DISPLAY_ONLY_FORM).find(':input').prop('disabled', true);

    submitPayload.expandedBucketCode = this.expandedBucketCode;
    submitPayload.isFilterPanelExpanded = this.isFilterPanelExpanded;

    if (_self.$el.find('.cta-sort-and-filter').data('searchkey') === true) {
      submitPayload['filterApplied'] = _self.$el.find('.cta-sort-and-filter').data('searchkey').toString();
    }
    
    this.refresh(submitPayload, function() {
      window.$(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-foundation');
      _self.showSortAndFilters();
      submitPayload.selectionOrder = _self.selectedOrder;
      var $submitForm = _self.$el.find(_self.options.SUBMIT_FORM);
      $.each($submitForm[0].elements, function(index, input) {
        if( submitPayload[input.name] && submitPayload[input.name].length )
          input.value = JSON.stringify(submitPayload[input.name])
      });
      $submitForm.find('[name="filter"]').val(submitPayload.filter);
    }, function(error) {
      window.location.replace(_self.$el.data(Constants.FILTER.ERROR_REDIRECT_URI));
    });
  },

  submitSortBy: function() {
    var submitPayload = this.serializeForm(),
        _self = this;
    submitPayload.selectionOrder = this.selectedOrder;
    var $submitForm = this.$el.find(this.options.SUBMIT_FORM);
    $.each($submitForm[0].elements, function(index, input) {
      if( submitPayload[input.name] && submitPayload[input.name].length ) {
        input.value = JSON.stringify(submitPayload[input.name])
      }
    });
    $submitForm.find('[name="filter"]').val(submitPayload.filter);
    $submitForm.submit();
  },

  /**
   * CTA handler for On Accordion Open
   */
  onAccordionOpen: function(evt) {
    var _self = this;
    var $acord = $(evt.currentTarget), $target = $(evt.target);
    if($target.closest('.js-brand-icon').hasClass('js-disabled-brand')){
      return false;
    }
    if( $acord.find('.t-icon-arrow-up').length ) {
      this.expandedBucketCode = $acord.find('.l-toggle-list').data('code');
    }
    _self.toggleHandler($acord);
  },
  /**
   * Toggle handler for Accordion
   */
  toggleHandler: function(toggleContainer) {
    toggleContainer.toggleClass('open');
    if (toggleContainer.hasClass('open')) {
      toggleContainer.find('.js-accordion-section').slideDown('fast', function() {
          $(this).css('overflow', 'visible');
      });
    } else {
      toggleContainer.find('.js-accordion-section').slideUp('fast');
    }
    toggleContainer.find(".t-caption-icon").toggleClass("t-icon-arrow-up").toggleClass("t-icon-arrow-down");
  },
  /**
   * CTA handler for On Accordion Open
   */
  adaAccordionOpen: function(evt) {
    var _self = this;
    var $acord = window.$(evt.currentTarget);
    $acord.trigger('click');
  },

  /**
   * CTA for reset button
   */
  resetForm: function() {
    var $elements = $(this.$el.find(this.options.DISPLAY_ONLY_FORM)[0].elements);
    $elements.prop('checked', false);
    var $submitForm = this.$el.find(this.options.SUBMIT_FORM);
    $submitForm.find('[name="action"]').val('clearAll');
    this.submitSortBy();
  },
  /*
    CTA for brand icons on desktop
  */
  brandIconClickHandler :  function _brandIconClickHandler (event) {
    event.preventDefault();
    var $currentTarget = $(event.currentTarget),
        $labelForSelector = $('label[for='+$currentTarget.data('for')+']');
    $labelForSelector.trigger('click');
  },
  /*
    Select all brands from category
  */
  selectAllCategoryLabels : function _selectAllCategoryLabels(event){
    event.preventDefault();
    event.stopPropagation();
    var _self = this;
    var brandList = $(event.currentTarget).closest('.l-brand-category').find('.js-brand-icon:not(.js-disabled-brand)');
    brandList.each(function(index,element){
      if(brandList.length-1==index){
        _self.$el.find('#'+$(element).data('for')).prop('checked', false);
        _self.$el.find('label[for='+$(element).data('for')+']').trigger('click');
      }else{
        var input = _self.$el.find('#'+$(element).data('for'));
        if(!input.prop('checked')){
          _self.selectedOrder.push(
            {"bucketName": input[0].name, "code": input[0].value, "label": _self.$el.find('[for="' + input[0].id + '"]').text() }
          );
          input.prop('checked', true);
        }
      }
    });
  },
    /*
      Clear all brands from category
    */
  clearAllCategoryLabels : function _clearAllCategoryLabels(event){
    event.preventDefault();
    event.stopPropagation();
    var _self = this,
    elementIndex=0,
    input={},
    brandList = $(event.currentTarget).closest('.l-brand-category').find('.js-brand-icon:not(.js-disabled-brand)');
    brandList.each(function(index,element){
      if(brandList.length-1==index){
        _self.$el.find('#'+$(element).data('for')).prop('checked', true);
        _self.$el.find('label[for='+$(element).data('for')+']').trigger('click');
      }else{
        input = _self.$el.find('#'+$(element).data('for'));
        if(input.prop('checked')){
         _self.selectedOrder.find(function(obj,index){
            if(obj.code == input[0].id){
              elementIndex = index;
            }
         });
        }
        _self.selectedOrder.splice(elementIndex,1);
        input.prop('checked', false);
      }
    });
  },

  /*
    Show all filters block
  */
  showAllFilters: function (event) {
    event.preventDefault();
    $(".tile-offer-nextgen-search-results, .m-footer").addClass("is-hidden-s");
  },

  /*
    hide all filters block
  */
  hideAllFilters: function (event) {
    event.preventDefault();
    $(".tile-offer-nextgen-search-results, .m-footer").removeClass("is-hidden-s");
  }

}));
